import { Card, Icon, IconLookup } from 'component-library-and-tools';
import { noop } from 'lodash-es';
import React from 'react';
import styled from 'styled-components';

import { SafelistTerm as SafelistTermType } from 'shared/types/safelist';
import { formatDate } from 'shared/utils/utils';
import { getReadableIndicatorType } from 'shared/utils/transformation';
import { colors } from 'lib/prisma-styles';

const StyledSafelistTerm = styled(Card)`
    && {
        min-width: 35rem;
        max-width: 45rem;
        background-color: ${colors.background.section};

        div {
            padding: unset;
        }
    }
`;

const StyledValueAndMetadata = styled.div`
    display: flex;
    flex-direction: column;

    flex-basis: 75%;
`;

// TODO this is identical to safelist summary, EXTRACT
const SafelistTermValue = styled.p`
    && {
        font-size: 1.1rem;
        font-weight: 700;
        margin: 0 0 0.25rem;
        max-width: 25rem;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
    }
`;

const StyledTermType = styled.p`
    display: flex;
    align-items: center;
    margin: 0 1rem 0 0;
    font-size: 1rem;

    text-transform: uppercase;
`;

const StyledActionButtonAndValueType = styled.div`
    display: flex;
    flex-grow: 1;
    justify-content: flex-end;
`;

const StyledSafelistTermMetadata = styled.div`
    display: flex;

    > p {
        margin-right: 0.25rem;
        font-size: 1rem;
    }
`;

const StyledTermCreatedBy = styled.p`
    margin: 0;
`;

const StyledTermCreatedTime = styled.p`
    margin: 0;
`;

const StyledIcon = styled(Icon)`
    display: flex;
    align-items: center;
`;

type SafeListTermProps = {
    term: SafelistTermType;
    className?: string,
    onDelete?: (termGuid: SafelistTermType) => void,
};

const SafelistTerm = ({ term, onDelete = noop, className }: SafeListTermProps) => {
    const handleDeleteIconClick = () => {
        onDelete(term);
    };

    return (
        <StyledSafelistTerm className={className}>
            <StyledValueAndMetadata>
                <SafelistTermValue title={term.entity}>
                    {term.entity}
                </SafelistTermValue>
                <StyledSafelistTermMetadata>
                    <StyledTermCreatedBy>{term.createdBy}</StyledTermCreatedBy>
                    <StyledTermCreatedTime>{formatDate(term.createdAt)}</StyledTermCreatedTime>
                </StyledSafelistTermMetadata>
            </StyledValueAndMetadata>
            <StyledActionButtonAndValueType>
                <StyledTermType>
                    {getReadableIndicatorType(term.type)}
                </StyledTermType>
                {/* TODO REPLACE ICON */}
                <StyledIcon icon={IconLookup.TRASH2} onClick={handleDeleteIconClick} />
            </StyledActionButtonAndValueType>
        </StyledSafelistTerm>
    );
};

export { SafelistTerm };
